<script lang="ts">
  import type { Swiper, SwiperOptions } from 'swiper/types';
  import ExtraSwiper from '../components/ExtraSwiper.svelte';
  import Icon from '../components/Icon.svelte';
  import StorySlideTemplate from './StorySlideTemplate.svelte';

  export let stories;
  export let mediaDisplayTime = 5;

  let theSwiper;
  let visible = false;
  let swiperOptions;

  $: storiesComposed = stories && composeStoriesMetadata(stories);

  function composeStoriesMetadata(stories) {
    return stories?.map(s => ({
      ...s,
      dataSwiperAutoplay: s.mimeType === 'VIDEO' ? 9999999 : mediaDisplayTime * 1000,
    }));
  }

  function getSwiperOptions(): SwiperOptions {
    return {
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: true,
      loop: true,
      autoplay: {
        delay: 3000,
      },
    };
  }

  export function showFullscreen(startingIndex = 0) {
    swiperOptions = getSwiperOptions();
    toggleVisibility(true);

    setTimeout(() => {
      (theSwiper as Swiper).slideTo(startingIndex, 0);
      (theSwiper as Swiper).autoplay.start();
    }, 200);
  }

  function onStorySlideChange(e) {
    const { detail: activeIndex } = e;
    handleVideoOnChangedSlide(activeIndex);

    window.ACC.mixpanel.trackStoryViewedEvent(activeIndex, storiesComposed);
    if (activeIndex === storiesComposed?.length - 1) {
      window.ACC.mixpanel.trackStoryCompletedEvent(activeIndex, storiesComposed);
    }
  }
  function handleVideoOnChangedSlide(latestActiveIndex: number) {
    // first stop all non-active videos
    document.querySelectorAll<HTMLVideoElement>('.swiper-slide video').forEach(v => {
      v.pause();
      v.currentTime = 0;
    });
    setTimeout(() => {
      if (storiesComposed[latestActiveIndex].mimeType === 'VIDEO') {
        const videoEl = document.querySelector<HTMLVideoElement>('.swiper-slide.swiper-slide-active video');
        if (videoEl) {
          videoEl.play();
          videoEl.addEventListener('ended', onVideoPlaybackFinished, { once: true });
        }
      }
    }, 1000);
  }
  function onVideoPlaybackFinished() {
    (theSwiper as Swiper).slideNext();
  }
  function toggleVisibility(visibleFlag) {
    visible = visibleFlag;
    const htmlEl = document.querySelector('html');
    if (visible) {
      htmlEl.classList.add('js-popin-open');
    } else {
      htmlEl.classList.remove('js-popin-open');
      theSwiper?.destroy();
    }
  }
</script>

{#if visible}
  <section class="extra-stories-thumbnail-component" class:slow-reveal={visible}>
    <section class="header">
      <button class="close-btn" on:click={() => toggleVisibility(false)}>
        <Icon glyph="close" size={24} />
      </button>
    </section>
    <section class="render-area">
      <ExtraSwiper
        bind:swiperInstance={theSwiper}
        slidesData={storiesComposed}
        slideTemplate={StorySlideTemplate}
        {swiperOptions}
        swiperClass="external-links-swiper"
        on:slideChange={onStorySlideChange}
      />
    </section>
  </section>
{/if}

<style lang="scss">
  @import '../styles/colors.new.scss';

  .extra-stories-thumbnail-component {
    position: fixed;
    height: 100vh;
    height: 100dvh;
    left: 0;
    right: 0;
    top: 0;
    padding: 28px 20px 14px;
    background-color: $primary-black;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    z-index: 99999;
    color: white;

    .header {
      display: flex;
      justify-content: flex-end;
    }
    .render-area {
      flex-grow: 1;
    }
    .header .close-btn {
      padding: 0;
      background: transparent;
      color: $functional-yellow;
      border: 0;
    }

    :global(.extra-swiper-container .swiper-pagination) {
      bottom: unset;
      top: 0;
    }
    :global(.swiper-wrapper) {
      padding-top: 18px;
    }
    :global(.extra-swiper-container .swiper-pagination .swiper-pagination-bullet) {
      background-color: $primary-yellow-01;
      opacity: 20%;
      width: 8px;
      height: 4px;
      border-radius: 20px;
      transition: all 250ms ease;
    }
    :global(.extra-swiper-container .swiper-pagination .swiper-pagination-bullet-active) {
      opacity: 100%;
      width: 16px;
    }

    &.slow-reveal {
      animation: slow-reveal-animation 250ms forwards;
    }
    @keyframes slow-reveal-animation {
      0% {
        opacity: 0;
      }
      80% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
  }
</style>
